import React, { Component } from "react";
//i18n
import { withNamespaces } from "react-i18next";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Button, Container } from "reactstrap";
import Loader from "../../components/Common/Loader";
//Import form component to render
import CreateWorkstationForm from "../../components/Forms/CreateWorkstationForm";
import "../Tables/datatables.scss";




class CreateWorkstation extends Component {
  constructor(props) {
    super(props);
    
    this.state = {
      user: JSON.parse(localStorage.getItem("authUser")),
      
    };
  }

  goBack(event){
    event.preventDefault()
    if(this.props.location.query){
      this.props.history.push(this.props.location.query.origin_path)
    }else{
      this.props.history.push("/workstations")
    }
   
  }
  render() {
    let user = this.state.user;
    if (!user) {
      return (
        <React.Fragment>
        <div className="loaderCenter">
        <Loader></Loader>
        </div>
 
      </React.Fragment>
      );
    }
    return (
      <React.Fragment>
        <div className="user-management">
          <Container fluid>
            {/* Render Breadcrumbs */}
            <Button className="btn btn-primary waves-effect waves-light  usersButtons" onClick={(event)=>this.goBack(event)}>
              <i class="fas fa-arrow-left"></i> 
            </Button>
            <CreateWorkstationForm />
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateProps = (state) => {
  return {  };
};
export default withRouter(
  connect(mapStateProps, {})(withNamespaces()(CreateWorkstation))
);
